import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { BreadcrumbsComponent } from './components/breadcrumbs.component';
import { BreadcrumbsEffects } from './store/breadcrumbs.effects';
import { BreadcrumbsReducer } from './store/breadcrumbs.reducer';

@NgModule({
    declarations: [
        BreadcrumbsComponent,
    ],
    imports: [
        CommonModule,
    ],
    exports: [
        BreadcrumbsComponent,
    ],
    providers: [
        provideState({ name: 'breadcrumbs', reducer: BreadcrumbsReducer }),
        provideEffects(BreadcrumbsEffects),
    ],
})

export class BreadcrumbsModule {}
